module.exports = __webpack_public_path__ + "media/intro_aful2_1080p.4c464a01.mp4";